<template>
  <div id="container" v-loading.fullscreen="loading">
    <div class="detail_main" v-if="list">
      <div class="searchResults">
        <div class="resultsBox full_layout">
          <span class="resultsSpan">{{ $t('colon.category') }}</span>
          <span class="resultsSpan">{{ list.Manufacturer }} > {{ list.CommodityType }} > {{ list.CommoditySeries }} > {{ list.CommodityYear }}</span>
        </div>
      </div>
      <div class="cardDetailsBox full_layout">
        <div class="cardDetails Release">
          <div class="sold ReleaseType" v-if="(CountDown(list.LastOnTime)!='00:00'&&list.Status==2)">{{$t('base.comingSoon')}}</div>
          <div v-if="(list.Status == 0)" class="sold QuantitySold">{{$t('base.soldOut')}}</div>
          <card-swiper :list="imgList" />
        </div>
        <!-- detail auction-->
        <buy-now :list='list' :postageList="postageList" v-if="list"/>
      </div>
      <!-- You May Also Like -->
      <like-swiper class="full_layout" />
      <div class="full_layout">
        <div class="bids_tabs">
          <div @click="BidsTabs(0)" :class="bidsTabs == 0 ? 'on' : ''">
            {{ $t('base.description') }}
          </div>
        </div>
        <div class="dasapDetails" ref='USA'>
          <div class="spacing" v-if="bidsTabs == 0">
            <div class="dasapDetails_title" v-if='list.Remark != null'>{{ $t('base.itemSpecifics') }}</div>
            <div class="condition" :class="list.Remark != null ? 'ifHide' : ''" v-if='list.Remark != null ' v-html='list.Remark!=null ? list.Remark : ""'>
            </div>
          </div>
        </div>
      </div>
    </div>
    <f-z-f :title="errorMsg" v-if="!loading && !list" />
  </div>
  <!-- 没商品显示默认报错界面 -->
</template>
<script>
import { countDown, getInfo, getTime, setUTC, priceExchange, GoYunXin, GetWorldUSD ,getAreaDetail} from "@/api/public";
import FZF from "@/components/404.vue";
import LikeSwiper from "@/components/swiper/like";
import CardSwiper from "@/components/swiper/card";
import BuyNow from "@/components/detail/buystore";

import qs from 'qs'

export default {
  name: "index",
  components: { LikeSwiper, CardSwiper,BuyNow, FZF },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      cid: '',
      oid:'',//商品id
      isFinish: false,
      loading: false,
      userInfo: null,
      list: '',
      postageList:'',
      TaxList: '', //税费列表
      WeightList: null,//重量列表
      listInfo: {},
      Properties: [],
      imgList: [],
      bidsTabs: 0,
      sellerInfo: '',
      isSeller: false,
      input: "",
      place_input: "",
      ByWay: 1,
      errorMsg: '',
      timer: "",
      SPercent: '',
      nowData: new Date().getTime(),
    };
  },
  filters: {
  },
  created() {
    //GetWorldUSD()
    //console.log("this.$route",this.$route);
    if(this.$route.query&&this.$route.query.oid){
      this.oid=this.$route.query.oid;//从订单进入商品详情，传入订单ID
    }
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    //console.log("created")
  },
  beforeRouteUpdate(to, from, next) {
    this.cid = to.params.id;
    this.userInfo = getInfo();
    this.getDetail();
    this.cardTimer()
    //console.log("beforeRouteUpdate",this.cid)
    next()
  },
  mounted() {
    this.getDetail()
    this.cardTimer()
    this.$root.$on("SPercent", val => {
      this.SPercent = val || 0;
    })
  },
  methods: {
    getAreaName(val,name){
      let areaName=getAreaDetail(val)
      let cardLang=this.$cookie.get('CardLang')
      return areaName[0].areaName
      //console.log(a,'a1111')
    },
    setAreaName(val, obj) {
      if (obj.OrderType != 1) {
        var val=this.$t('base.nationalDefaultArea')
        if (val == this.$t('base.nationalDefaultArea')) {
          val = this.$t('base.defaultArea')
        }
      }
      return val
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 获取倒计时
    CountDown(itemEnd, val) {
      //itemEnd = itemEnd.toString().replace(/-/g, "/")
      let i = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      if (val == 0) {
        if (countDown(i, newval) == "00:00") {
          this.$emit('acution')
        }
      }
      //console.log(i, newval, itemEnd)
      //console.log(itemEnd)
      return countDown(i, newval)
    },
    //
    allContact(val) {
      if (this.userInfo) {
        GoYunXin(this.userInfo, val)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    // 获取商品详情
    getDetail() {
      this.loading = true
      let that = this;
      let data = { 'AreaCode': 'US', 'Id': this.cid}
      if (that.userInfo != null) {
        data.AreaCode=that.userInfo.MemberSource
        if(that.userInfo.Count&&that.userInfo.Count>0){
          data.Province=that.userInfo.State
        }
      }
      that.$get(that.$interface.GetDetail, data).then(res => {
        if (res.Result != 0) {
          let data = res.Data.Commodity
         // console.log("data", data)
          //console.log(data.images.split(','))
          document.title = data.Title;
          that.imgList = data.Imgs
          that.list = data;
          that.postageList=JSON.parse(res.Data.PostageData).Data

          
          // if (that.userInfo != null) {
          //   that.getSeller()
          // }
         // that.GetStoresList()
          //that.getPostageList()
        } else {
          that.list = null;
          that.errorMsg = res.msg
        }
        that.loading = false
      })
    },
    // 获取邮费列表
    getPostageList(){
      let that=this
      let data = { 'AreaCode': 'US'}
      if (that.userInfo != null) {
        data.AreaCode=that.userInfo.MemberSource
      }
      that.$get(that.$interface.GetPostageById, data).then(res => {
          if (res.Result != 0) {
            let data = res.Data
            that.postageList=data
          }
      })
    },
    // 关注商家
    setAttention() {
      let that = this;
      if (that.userInfo != null) {
        let data = { 'selluserid': that.list.SellUserID, 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId }
        this.$post(that.$interface.SetAttention, qs.stringify(data)).then(res => {
          if (res.result != 0) {
            // that.sellerInfo.IsAttention=!that.sellerInfo.IsAttention
            that.GetStoresList()
          }
        })
      }
    },
    BidsTabs(val) {
      this.bidsTabs = val
      //console.log("BidsTabs",val)
    },
    //保存游览记录
    getSeller() {
      let that = this
      let data = { 'MemberId': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, CommodityId: this.$route.params.id }
      this.$post(this.$interface.SaveTourHistory, qs.stringify(data)).then(res => {

      }).catch(error => {

      })
    },
    //获取商家信息
    GetStoresList(val) {
      let that = this
      let data = { 'Id': that.list.SellUserID, 'MemberId': '' }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        if (res.result != 0) {
          //console.log(that.sellerInfo)
          that.sellerInfo = res.data
        }
      })
    },
    updateDetail() {
      this.getDetail();
    },
    auctionFinish() {
      this.isFinish = true;
    },
    ISUS() {
      this.bidsTabs = 1;
      window.scrollTo(0, 2000)
    },
    IsPremium(val) {
      this.bidsTabs = val;
      window.scrollTo(0, 2000)
    }
  },
};

</script>
<style scoped>
@import "../../../static/css/carddetails.css";

/* .descriptionBox{
  margin-bottom: 40px;
} */
.tosell span {
  color: #5f6dae;
  cursor: pointer;
}

.tosell span:hover {
  text-decoration: underline;
}

.cardDetails.Release {
  position: relative;
}

.cardDetails.Release .sold {
  position: absolute;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 9;
  background-size: auto 100%;
  right: 0;
  bottom:0;
  bottom: 98px;
    border-radius: 0 0 4px 4px;
}

.cardDetails.Release .ReleaseType {
  /*background-image: url(../../../static/images/comingsoon.svg);*/
  background-color: #5F6DAE;
}

.cardDetails.Release .QuantitySold {
  /*background-image: url(../../../static/images/soldout.svg);*/
  background-color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// src/pages/carddetails/store.vue